import { TestTemplateComponent } from './test-template.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { TranslateDirective, TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer'

@NgModule({
  declarations: [TestTemplateComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    TranslateModule,
    ContentEditableModule,
    NgSelectModule,
    NgxExtendedPdfViewerModule,
  ],
  exports: [TestTemplateComponent],
})
export class TestTemplateModule {}
